
    export default {
      mounted() {
        this.fit = () => {
          const top = this.el.getBoundingClientRect().top
          // leave an 8px gutter at the bottom; never shrink below 24rem
          const h = Math.max(384, Math.round(window.innerHeight - top - 8))
          this.el.style.height = h + "px"
        }
        this.schedule = () => {
          if (this._raf) return
          this._raf = requestAnimationFrame(() => { this._raf = null; this.fit() })
        }
        this.fit()
        // re-measure once layout/fonts settle
        requestAnimationFrame(() => this.fit())
        window.addEventListener("resize", this.schedule, { passive: true })
      },
      updated() { this.fit && this.fit() },
      destroyed() {
        window.removeEventListener("resize", this.schedule)
        if (this._raf) cancelAnimationFrame(this._raf)
      }
    }
  